import React, { ReactElement } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import { Svg } from 'ui'
import FAQIcon from 'images/freeDNS/FAQ-icon.svg'
import FaqItemAccordion from './FaqItemAccordion'
import Gradient from 'images/organization/features/malware/faq-gradient.svg'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export interface FAQItem {
  question: string
  answer: ReactElement
}

const FrequentlyAskedQuestions = ({
  data,
  sx,
}: {
  data: FAQItem[]
  sx?: ThemeUIStyleObject
}): ReactElement => {
  return (
    <Flex
      sx={{
        position: 'relative',
        justifyContent: 'center',
        width: '100%',
        px: ['1.6rem', '1.6rem', 0],
        ...sx,
      }}
    >
      <Flex
        sx={{
          width: ['100%', '76.4rem'],
          flexDirection: 'column',
          textAlign: 'center',
        }}
      >
        <Flex sx={{ flexDirection: 'column', position: 'relative' }}>
          <Flex sx={{ justifyContent: 'center', mb: '1.6rem' }}>
            <Svg
              svg={FAQIcon}
              sx={{ justifyContent: 'center' }}
              descriptiveText="FAQ section icon"
            />
          </Flex>
          <TextWithBreakpointVariant
            as="h2"
            variant={['size24Weight600', 'size40Weight600']}
            sx={{
              mb: '4.8rem',
              color: 'aliceBlue',
              zIndex: 'zIndex1',
            }}
          >
            Frequently asked questions
          </TextWithBreakpointVariant>

          <Svg
            svg={Gradient}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              zIndex: 'zIndex0',
            }}
            descriptiveText="FAQ section background gradient"
          />
        </Flex>
        <Flex
          sx={{
            flexDirection: 'column',
            gap: '1.6rem',
            zIndex: 'zIndex1',
          }}
        >
          {data.map((item, index) => (
            <FaqItemAccordion key={index} item={item} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default FrequentlyAskedQuestions
